import api from '@/apis/pu/pUInvoiceAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('pUInvoice', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pu_invoice',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load danh sách công nợ phải trả (override lại để chỉnh lại API)
   */
  async loadPUInvoice(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      res = await api.getListPUInvoice(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }
    
    context.commit('updatePayloadNextBack', {...payload});
    if (res && !payload.isNextBack) {
      context.commit('setPaging', res);
    }

    return res;
  },
  /**
   * Load danh sách công nợ phải trả (override lại để chỉnh lại API)
   */
  async loadSummaryPUInvoice(context, payload) {
    let res = null;
    try {
      context.commit('updateLoadingSummary', true);
      res = await api.getListSummaryPUInvoice(payload || {});
    } finally {
      context.commit('updateLoadingSummary', false);
    }

    if (res) {
      context.commit('setPaging', res);
      context.commit('setPayload', payload);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
